import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import parse from "html-react-parser";
import DateTimeSelectionModal from './DateTimeSelectionModal';
import './Cart.css';

const Cart = () => {
  const { isAuthenticated } = useAuth();
  const { cartItems, removeFromCart, updateQuantity, clearCart, getTotalPrice, getTotalItems, setSelectedDateTimeSlot } = useCart();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isDateTimeModalOpen, setIsDateTimeModalOpen] = useState(false);

  const handleCheckout = () => {
    if (!isAuthenticated) {
      // Redirect to login page if not authenticated
      setIsOpen(false);
      navigate('/auth');
      return;
    }

    // If authenticated, show date/time selection modal
    setIsOpen(false);
    setIsDateTimeModalOpen(true);
  };

  const handleDateTimeConfirm = (dateTime) => {
    setSelectedDateTimeSlot(dateTime);
    setIsDateTimeModalOpen(false);
    navigate('/payment');
  };

  const handleDateTimeModalClose = () => {
    setIsDateTimeModalOpen(false);
  };

  if (cartItems.length === 0 && !isOpen) {
    return null;
  }

  return (
    <>
      <DateTimeSelectionModal
        isOpen={isDateTimeModalOpen}
        onClose={handleDateTimeModalClose}
        onConfirm={handleDateTimeConfirm}
      />
      {/* Cart Toggle Button */}
      <div className="cart-toggle" onClick={() => setIsOpen(!isOpen)}>
        <span className="cart-icon">🛒</span>
        {getTotalItems() > 0 && (
          <span className="cart-badge">{getTotalItems()}</span>
        )}
      </div>

      {/* Cart Sidebar */}
      {isOpen && (
        <div className="cart-overlay" onClick={() => setIsOpen(false)}>
          <div className="cart-sidebar" onClick={(e) => e.stopPropagation()}>
            <div className="cart-header">
              <h2>Shopping Cart</h2>
              <button className="cart-close-btn" onClick={() => setIsOpen(false)}>
                ×
              </button>
            </div>

            <div className="cart-content">
              {cartItems.length === 0 ? (
                <div className="cart-empty">
                  <p>Your cart is empty</p>
                  <span className="empty-cart-icon">🛒</span>
                </div>
              ) : (
                <>
                  <div className="cart-items">
                    {cartItems.map((item) => (
                      <div key={item.id} className="cart-item">
                        <div className="cart-item-info">
                          <h4 className="cart-item-name">{item.name}</h4>
                          <p className="cart-item-description">{parse(item.description)}</p>
                                  
                          <div className="cart-item-price">
                            ₹{item.pricePerHour}/hr × {item.quantity} = ₹{item.pricePerHour * item.quantity}
                          </div>
                        </div>
                        <div className="cart-item-controls">
                          <div className="quantity-controls">
                            <button
                              className="quantity-btn"
                              onClick={() => updateQuantity(item.id, item.quantity - 1)}
                            >
                              −
                            </button>
                            <span className="quantity-value">{item.quantity}</span>
                            <button
                              className="quantity-btn"
                              onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            >
                              +
                            </button>
                          </div>
                          <button
                            className="remove-btn"
                            onClick={() => removeFromCart(item.id)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="cart-footer">
                    <div className="cart-total">
                      <div className="total-row">
                        <span>Total Items:</span>
                        <span>{getTotalItems()}</span>
                      </div>
                      <div className="total-row total-price-row">
                        <span>Total Price:</span>
                        <span>₹{getTotalPrice()}</span>
                      </div>
                    </div>
                    <div className="cart-actions">
                      <button className="clear-cart-btn" onClick={clearCart}>
                        Clear Cart
                      </button>
                      <button
                        className="checkout-btn"
                        onClick={handleCheckout}
                      >
                        Checkout
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Cart;

